/** @file Rig JSON codes of inherit and blend names (§5.4): the index order of the document enums. */
import { INHERIT_CODES } from '@pose2d/core/pose/inheritCodes';
import type { Blend, InheritMode } from '@pose2d/core/types';
import type { BlendName, Inherit } from '@pose2d/format/types';

/** Name → code tables: inherit is core's INHERIT_CODES (W2-14); blend's `Record` keeps it exhaustive. */
export const COMPILE_CODES: { readonly inherit: Readonly<Record<Inherit, InheritMode>>; readonly blend: Readonly<Record<BlendName, Blend>> } = {
  inherit: INHERIT_CODES,
  blend: { normal: 0, additive: 1, multiply: 2, screen: 3 },
};
